const GROOVEMAN_AI_ENDPOINT = '/apps/grooveman-ai-lab';
async function groovemanGenerateDesign(prompt) {
  const response = await fetch(GROOVEMAN_AI_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt })
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Generation failed');
  }

  return result;
}
document.addEventListener('click', async function(event) {
  const button = event.target.closest('.gmai__generate');
  if (!button) return;

  const root = button.closest('[data-gmai]');
  const prompt = root?.querySelector('#gmai-prompt')?.value.trim();
const style = root?.querySelector('input[name="gmai-style"]:checked')?.value || 'cartoon';
  if (!prompt || prompt.length < 3) {
    alert('Please describe your design first.');
    return;
  }

  button.disabled = true;
  button.textContent = 'GENERATING...';

  try {
  
const stylePrompts = {
  realistic: 'Premium photorealistic artwork, lifelike textures, natural lighting, realistic proportions, rich detail, professional visual composition.',
  cartoon: 'Exceptional 3D cartoon illustration, expressive original characters, dimensional depth, polished rendering, vibrant colors, playful personality, rich supporting details.',
  streetwear: 'Premium original streetwear graphic, bold creative composition, striking contrast, sophisticated urban fashion aesthetic, expressive details, impactful typography only when requested. Incorporate money, luxury, music, graffiti or other thematic elements only when relevant to the customer request.',
  art: 'Original contemporary art and pop art illustration, gallery-quality creative composition, expressive color blocking, artistic textures, dynamic shapes, layered visual details, bold contrast and imaginative visual storytelling.'
};

const stylePrompt = stylePrompts[style] || stylePrompts.cartoon;

const result = await groovemanGenerateDesign(
  prompt +
  '. Visual style: ' + stylePrompt +
  ' Create an exceptional, original, professionally finished graphic specifically composed for printing on a T-shirt. Favor a balanced vertical composition suitable for a 14 x 16 inch print area, without forcing the artwork to fill the entire area. Make the central subject visually compelling, with thoughtfully integrated supporting elements when appropriate. The design should feel complete, cohesive, distinctive and premium, never generic or unfinished. Match the complexity to the requested aesthetic: elaborate when appropriate, clean and restrained when minimalism is requested. Include text or slogans only when explicitly requested by the customer. Preserve accurate spelling of any requested text. Strong visual hierarchy, crisp details, clean edges, transparent background, isolated artwork, no scenery, no T-shirt mockup, no rectangular background, print-ready graphic.'
);

    const imageUrl = GROOVEMAN_AI_ENDPOINT + '?design_id=' + encodeURIComponent(result.design_id);
    const preview = root.querySelector('[data-gmai-result]');
preview.hidden = false;
const imageContainer = preview.querySelector('[data-gmai-result-image]');
imageContainer.replaceChildren();

const image = document.createElement('img');
image.src = imageUrl;
image.alt = 'Your AI-generated T-shirt design';
image.style.cssText = 'display:block;max-width:100%;max-height:420px;margin:20px auto;';

imageContainer.appendChild(image);
root.dataset.generatedDesignId = result.design_id;
  } catch (error) {
    alert('Unable to generate design: ' + error.message);
  } finally {
    button.disabled = false;
    button.textContent = 'GENERATE MY DESIGN';
  }
});
(()=>{function init(root){if(root.dataset.gmaiReady)return;root.dataset.gmaiReady='1';const buttons=[...root.querySelectorAll('[data-gmai-option]')],panel=root.querySelector('[data-gmai-panel]'),hint=root.querySelector('[data-gmai-hint]');buttons.forEach(button=>button.addEventListener('click',()=>{const ai=button.dataset.gmaiOption==='ai';buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));panel.hidden=!ai;hint.hidden=ai;}));}function start(){document.querySelectorAll('[data-gmai]').forEach(init)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();document.addEventListener('shopify:section:load',start);})();
document.addEventListener('click', async (event) => { const btn = event.target.closest('[data-gmai-use-design]'); if (!btn) return; const root = btn.closest('[data-gmai]'); const id = root?.dataset.generatedDesignId; const designer = document.querySelector('grooveman-shirt-designer'); if (!id || !designer) return; try { btn.disabled = true; const response = await fetch('/apps/grooveman-ai-lab?design_id=' + encodeURIComponent(id)); if (!response.ok) throw new Error('Image unavailable'); const blob = await response.blob(); const file = new File([blob], 'grooveman-ai-design.png', { type: 'image/png' }); const input = designer.fileInputs?.front;
if (input) {
  const transfer = new DataTransfer();
  transfer.items.add(file);
  input.files = transfer.files;
  input.dispatchEvent(new Event('change', { bubbles: true }));
} else {
  designer.loadFile('front', file);
} designer.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (error) { alert('Unable to load AI design: ' + error.message); } finally { btn.disabled = false; } });
window.groovemanLoadSavedDesign = function(id) { const root = document.querySelector('[data-gmai]'); if (!root || !id) return; const preview = root.querySelector('[data-gmai-result]'); const container = root.querySelector('[data-gmai-result-image]'); if (!preview || !container) return; const img = document.createElement('img'); img.src = GROOVEMAN_AI_ENDPOINT + '?design_id=' + encodeURIComponent(id); img.alt = 'Saved AI design'; img.style.cssText = 'display:block;max-width:100%;max-height:420px;margin:20px auto;'; container.replaceChildren(img); root.dataset.generatedDesignId = id; preview.hidden = false; };
